// extracted by mini-css-extract-plugin
export default {"title":"styles_title__dQvP4","list":"styles_list__udNsF","anchor":"styles_anchor__pGnU9"};